import {CdFrequencyType} from '../../../interfaces/care/cd-care-plan/cd-frequency-type';

export class CdFrequencyTypeFactory {

  /**
   *
   * @param cdFrequencyType
   */
  public static fromObject(cdFrequencyType: any): CdFrequencyType {
    return new class implements CdFrequencyType {
      created: string = cdFrequencyType.created;
      hasOpPeriod: boolean = cdFrequencyType.has_op_period;
      id: number = cdFrequencyType.id;
      modified: string = cdFrequencyType.modified;
      name: string = cdFrequencyType.name;
      shortName: string = cdFrequencyType.short_name;
      userId: number = cdFrequencyType.user_id;
      measureServiceLevel: number = cdFrequencyType.measure_service_level;
      prescriptionServiceLevel: number = cdFrequencyType.prescription_service_level;
      withAnyService: boolean = cdFrequencyType.with_any_service;
    };
  }

  /**
   *
   * @param cdFrequencyTypes
   */
  public static fromArray(cdFrequencyTypes: CdFrequencyType[]): CdFrequencyType[] {
    return cdFrequencyTypes.map(_cdFrequencyType => CdFrequencyTypeFactory.fromObject(_cdFrequencyType));
  }

}
